import { Component, ElementRef, ViewChild } from '@angular/core';
import chartsEmbedDom, { Chart } from '@mongodb-js/charts-embed-dom';
import { Store } from '@ngrx/store';
import { combineLatest, Subject } from 'rxjs';
import { filter, map, takeUntil, startWith } from 'rxjs/operators';
import { authOrgSelector } from 'src/app/auth/store/auth.selectors';
import { State } from 'src/app/store';
import { environment } from 'src/environments/environment';
import { organisationSelector, dashboardUrlSelector } from '../../store/global.selectors';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent {
    private destroy$ = new Subject();
    environment = environment;

    iframeSrc$ = combineLatest([
        this.store.select(dashboardUrlSelector),
        this.store.select(authOrgSelector),
        this.store.select(organisationSelector),
        this.translate.onLangChange.pipe(startWith(this.translate.currentLang)),
    ]).pipe(
        takeUntil(this.destroy$),
        filter(([dashboardUrl, orgTag, organisation]) => !!dashboardUrl && !!orgTag && !!organisation),
        map(([dashboardUrl, orgTag, organisation]) => {
            const cityOptions = `&filter=${JSON.stringify({ organisation: orgTag, city: organisation.name })}`;
            const scaleOptions = '&scalingWidth=scale&scalingHeight=fixed';

            let url = typeof dashboardUrl === 'string' ? dashboardUrl.trim() : dashboardUrl[this.translate.currentLang].trim();

            if (url.includes('charts.mongodb.com')) {
                url += `${scaleOptions}${cityOptions}`;
            } else {
                url += `${cityOptions}`;
            }
            return url;
        }),
    );

    _chartsSdk: chartsEmbedDom;
    _chart: Chart;

    @ViewChild('dashboard') _dashboardRef: ElementRef;

    constructor(
        private store: Store<State>,
        public translate: TranslateService,
    ) {}

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
